export default "__VITE_ASSET__p4YSEod4__"